import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FlowPage } from '../flow-director';
import { ModalService } from '../../services/ui/modal/modal.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { YshFlowNavBarComponent } from "../../components/ysh-flow-nav-bar/ysh-flow-nav-bar.component";
import { YshFlowContentComponent } from "../../components/ysh-flow-content/ysh-flow-content.component";
import { YshButtonControlComponent } from "../../components/ysh-button-control/ysh-button-control.component";
import { FormField, YshFormComponent } from "../../components/ysh-form/ysh-form.component";
import { Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { ToastService } from '../../services/ui/toast/toast.service';
import { CompanyService } from '../../services/api/company/company.service';
import { Company, CreateCompanyParams } from '../../models/company';

@Component({
    selector: 'ysh-add-company',
    templateUrl: './add-company.page.html',
    styleUrl: './add-company.page.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        YshFlowNavBarComponent,
        YshFlowContentComponent,
        YshButtonControlComponent,
        YshFormComponent
    ]
})
export class AddCompanyPage implements OnInit, FlowPage {
  @Input() onComplete: (company: Company) => void;
  @Input() onDismiss?: () => void;

  constructor(
    private analytics: AnalyticsService,
    private companyService: CompanyService,
    private modalService: ModalService, 
    private toastService: ToastService,
  ){}

  formFields: FormField[] = [
    { 
      name: 'companyName',
      label: 'Company Name',
      type: 'text',
      icon: 'people_alt',
      validators: [Validators.required]
    },
  ];

  ngOnInit(): void {
    this.analytics.trackView('AddCompanyPage');
  }

  async didTapSubmitCompany(formValues: any): Promise<void> {
    try {
      const createCompanyParams: CreateCompanyParams = {
        name: formValues.companyName
      };
      const company = await firstValueFrom(this.companyService.create(createCompanyParams));
      this.modalService.dismiss();
      this.toastService.show('success', 'Company Added!');
      this.onComplete?.(company);
    } catch (error) {
      console.error(error);
      throw error;
    }
  } 

  didTapDismiss() {
    this.modalService.dismiss();
    this.onDismiss?.();
  }
}
